<script lang="ts">
  import { emptyStateId } from '@pin/client-state-observable';
  import type { State } from '@pin/schemas/client-state-response';
  import { isFuture } from 'date-fns';
  import Loader from '../components/Loader.svelte';
  import Logo from '../components/MGP/Logo.svelte';
  import { loginSessionStore } from '../login/loginSessionStore';
  import { clientState } from '../util/stores';
  import After from '../views/After.svelte';
  import Before from '../views/Before.svelte';
  import Closed from '../views/Closed.svelte';
  import Empty from '../views/Empty.svelte';
  import Login from '../views/Login.svelte';
  import Open from '../views/Open.svelte';
  import Poster from '../views/Poster.svelte';

  $: isOpen = checkOpen($clientState);
  $: loading = $clientState.id === emptyStateId || $loginSessionStore == null;

  const checkOpen = (clientState: State | undefined) =>
    clientState?.type == 'open' ||
    (clientState?.type === 'closing' &&
      isFuture(new Date(clientState.endTime)));
</script>

<Logo {loading} />

{#if clientState == null}
  <Empty />
{:else if loading}
  <Loader description="Laster avstemning" />
{:else if $clientState.type === 'closing' && !isOpen}
  <Closed pollData={$clientState} />
{:else if $clientState.type === 'after'}
  <After pollData={$clientState} />
{:else if $clientState.type === 'poster'}
  <Poster pollData={$clientState} />
{:else if !$loginSessionStore?.user}
  <Login />
{:else if $clientState.type === 'before'}
  <Before pollData={$clientState} />
{:else if $clientState.type === 'open' || $clientState.type === 'closing'}
  <Open pollData={$clientState} />
{/if}
